import { Decoration, DecorationSet } from 'prosemirror-view'
import { Plugin, PluginKey, TextSelection } from 'prosemirror-state'

const ListItemMarkerSelectionPluginKey = new PluginKey('ListItemMarkerSelection')

export const ListItemMarkerSelection = new Plugin({
  key: ListItemMarkerSelectionPluginKey,
  props: {
    decorations: (state) => {
      const { empty, from, to } = state.selection

      if (empty) return DecorationSet.create(state.doc, [])

      const decorations: Decoration[] = []

      state.doc.nodesBetween(from, to, (node, pos) => {
        // text selections can only start inside text wrapping nodes, so we
        // need to add/subtract 2 to the position before or after the list item
        // to check if a selection starts or ends at least there
        const selected = from <= pos + 2 && pos + node.nodeSize - 2 <= to
        if (!selected) {
          return
        }
        if (node.type === state.schema.nodes.list_item) {
          decorations.push(
            Decoration.node(pos, pos + node.nodeSize, {
              class: 'selectedMarker',
            }),
          )
          return
        }
        if (node.type === state.schema.nodes.summary) {
          const $pos = state.doc.resolve(pos + 1)
          decorations.push(
            Decoration.node($pos.before(-1), $pos.after(-1), {
              class: 'selectedMarker',
            }),
          )
        }
      })

      return DecorationSet.create(state.doc, decorations)
    },
    handleClickOn: (view, pos, node, nodePos, event, direct) => {
      const {
        dispatch,
        state: { doc, schema, tr },
      } = view

      if (direct && node.type === schema.nodes.list_item) {
        const $pos = doc.resolve(pos)

        tr.setSelection(TextSelection.create(doc, $pos.before(), $pos.after()))
        dispatch(tr)

        return true
      }

      return false
    },
    handleDoubleClickOn: (view, pos, node, nodePos, event, direct) => {
      const {
        dispatch,
        state: { doc, schema, tr },
      } = view

      if (direct && node.type === schema.nodes.list_item) {
        const $pos = doc.resolve(pos)

        tr.setSelection(TextSelection.create(doc, $pos.before($pos.depth - 1), $pos.after($pos.depth - 1)))
        dispatch(tr)

        return true
      }

      return false
    },
  },
})
